const tel = (tel = '') => `callto:${(tel || '').replace(/\s/g, '')}`;

export default tel;
